export const getBackgroundByStatusValue = (
  status: string | undefined | null
) => {
  if (status === undefined || status === null) {
    return '#fff';
  }
  switch (status) {
    case 'OK':
      return '#20c997';
    case 'NG':
      return '#ff0000';
    case 'UNDER APPROVAL':
      return '#ffd43b';
    default:
      return '#fff';
  }
};
